import { endpoints } from '../api/endpoints';
import { queryKeys } from './queryKeys';
import { queryConfig } from './queryConfig';
import { createListQueryHook } from './queryFactory';

export const useFAQ = createListQueryHook({
  queryKey: queryKeys.faq.questions(),
  endpoint: endpoints.faq.questions,
  config: {
    staleTime: queryConfig.staleTime.short,
  },
});

